import { AnalyticsTraficComponent } from './analytics-traffic.component';
export default AnalyticsTraficComponent;
